<template>
  <div>
    <div class="inbanner bg-cover">
        <el-image src="images/lb/xwzx.jpg"></el-image>

      <!-- <div class="inwrap l-m-c">
        <h2 class="fnt_40 wow fadeInUp animated animated" style="visibility: visible; animation-name: fadeInUp;">新闻中心</h2>
        <h3 class="fnt_18 wow fadeInUp animated animated" data-wow-delay="0.2s" style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">Product center</h3>
      </div> -->
    </div>
    <section class="row bar bg-gray no-mb padding-big text-md-center">
    <div id="content">
      <div
        style="  padding-right:150px;padding-left:150px;"
 
      >
        <div class="row bar">
 
          <!-- services -->
	<div   >
		<div    style="  padding-right:150px;padding-left:150px;"> 
		<div class="ser-wthree">
			<div style="position: relative;">   
				<div style="margin-top: 10px;" class="col-sm-3 col-xs-6   animate__animated  animate__slideInUp  animate__faster  animation-duration: 2s;" v-for="(item, index) in newlist" :key="index">
					<div class="ser-agile" style="height:400px;" >
						<div class="services-icon hvr-radial-in">
							new
						</div>
						<h4> {{item.newTitle}} </h4>
						<p>  作者：  {{item.author}}</p>
            <span class="date-comments">
                 {{item.createTime}}   
                    </span>
          <span class="read-more text-right" @click="gotoDetail(item)" style="text-decoration: underline; float: right;; color: lightseagreen;">
                    详情
                    <!-- <router-link :to="{path:'/newDetail',query: {id:item.id},params:{currentNew:'ssssssssss'}}" >详情</router-link> -->
                  </span>
					</div>

				</div>
        <div class="clearfix"> </div> 
        <p><a href="#" class="btn btn-template-main" style="margin-top: 30px;">更多</a></p>
				<div class="clearfix"> </div> 
			</div>
      <!-- <Pagination
              :current-page="currentPage"
              :page-size="pageSize"
              :total="totalItems"
              @page-changed="handlePageChanged"
            /> -->
			</div>
		</div>
	</div>
	<!-- //services -->
          <!-- <div class="col-md-3">
            <div class="panel panel-default sidebar-menu">
              <div class="panel-heading">
                <h3 class="h4 panel-title">
                  搜索
                </h3>
              </div>
              <div class="panel-body">
                <form role="搜索">
                  <div class="input-group">
                    <input
                      type="text"
                      placeholder="搜索"
                      class="form-control"
                    ><span class="input-group-btn">
                      <button
                        type="submit"
                        class="btn btn-template-main"
                      ><i class="fa fa-搜索" /></button></span>
                  </div>
                </form>
              </div>
            </div>
            <div class="panel panel-default sidebar-menu">
              <div class="panel-heading">
                <h3 class="h4 panel-title">
                  分类
                </h3>
              </div>
              <div class="panel-body">
                <ul class="nav nav-pills flex-column text-sm">
                  <li class="nav-item">
                    <a
                      href="blog.html"
                      class="nav-link"
                    >集团</a>
                  </li>
                  <li class="nav-item">
                    <a
                      href="blog.html"
                      class="nav-link active"
                    >太药</a>
                  </li>
                  <li class="nav-item">
                    <a
                      href="blog.html"
                      class="nav-link"
                    >众方</a>
                  </li>
                  <li class="nav-item">
                    <a
                      href="blog.html"
                      class="nav-link"
                    >立业</a>
                  </li>
                </ul>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    </section>
  </div>
</template>
<style>
.ser-agile:hover {
  background-color: red;
}
</style>
<script>
import * as  http from '@/request/http'
import { useRouter} from 'vue-router';
import { useStore } from 'vuex';
// import Pagination from '@/components/PaginationCom.vue';
import 'animate.css'
export default {
   components: {
      // Pagination
    },
   data(){
    return {    
      currentPage: 1,
      pageSize: 10,
      totalItems: 1,  
      newlist:[],
      newsdata:{}
    }
   },
   methods: {
    handlePageChanged(newPage) {
       let  param = {
          newTitle: '',
          currentPage: this.currentPage,
          pageSize: 10,
          type:''
       }
        this.currentPage = newPage;
        http.news.newslistPage(param).then(res=>{
           console.log(res.data) 
           this.newsdata = res.data,
           this.newlist=res.data.rows
           this.currentPage =newPage;
           this.pageSize=10;
           this.totalItems=res.data.total
        })
      },
   },
   created(){
    this.handlePageChanged(1)
 
   },
   props: {
    user: Object
  },
  setup() {
    const router = useRouter();
    // 使用全局$store
    const store = useStore();
 
    function gotoDetail(item) {
      const state= item
      // router.push({ name: 'NewDetail', params: {id:2} });
      store.state.newStore.currentNew=item
      router.push({ name: 'NewDetail',state});
    }
    return {
      gotoDetail
    };
  }
}
</script>